// @ts-ignore
const variablesFiles = import.meta.glob<{ default: string }>(
  "../themes/*/*/variables.css",
  {
    eager: true,
    query: "?url&no-inline",
  }
);

// @ts-ignore
const fontsFiles = import.meta.glob<{ default: string }>(
  "../themes/*/*/fonts.css",
  {
    eager: true,
    query: "?url&no-inline",
  }
);

export function lazyHead(
  organizationSlug: string,
  projectSlug: string,
  defaultOrganizationSlug: string,
  defaultProjectSlug: string
) {
  const returnValue: { rel: string; id?: string; href: string }[] = [];
  let fontsFile =
    fontsFiles[`../themes/${organizationSlug}/${projectSlug}/fonts.css`];
  if (!fontsFile) {
    if (import.meta.env.DEV) {
      console.warn(
        `Fonts for theme ${organizationSlug}/${projectSlug} not found`
      );
    }
    fontsFile =
      fontsFiles[
        `../themes/${defaultOrganizationSlug}/${defaultProjectSlug}/fonts.css`
      ];
  }
  if (fontsFile.default) {
    returnValue.push({
      rel: "stylesheet",
      id: "theme-fonts",
      href: fontsFile.default,
    });
  }

  let variablesFile =
    variablesFiles[
      `../themes/${organizationSlug}/${projectSlug}/variables.css`
    ];
  if (!variablesFile) {
    if (import.meta.env.DEV) {
      console.warn(
        `Variables for theme ${organizationSlug}/${projectSlug} not found`
      );
    }
    variablesFile =
      variablesFiles[
        `../themes/${defaultOrganizationSlug}/${defaultProjectSlug}/variables.css`
      ];
  }
  if (variablesFile.default) {
    returnValue.push({
      rel: "stylesheet",
      id: "theme-variables",
      href: variablesFile.default,
    });
  }

  return returnValue;
}
